import {combineReducers} from 'redux';
import {collaborateReducer} from './collaborate';
import {commentsReducer} from './comments';
import currentTripboardReducer from './current-tripboard-reducer';
import createTripboardReducer from './create-tripboard-controls/create-tripboard-reducer';
import tripboardsReducer from './tripboard-reducer';
import {recommendedPropertiesReducer} from './recommended-properties';
import listingDeleteModalReducer from './listing-delete-modal/reducer';


const combined = combineReducers({
    collaborate: collaborateReducer,
    comments: commentsReducer,
    currentTripboard: currentTripboardReducer,
    recommendations: recommendedPropertiesReducer,
    tripboards: tripboardsReducer,
    createControls: createTripboardReducer,
    listingDeleteModal: listingDeleteModalReducer
});

export default combined;



// WEBPACK FOOTER //
// ./src/universal/tripboard/reducer.js